module.exports = __webpack_public_path__ + "static/media/Cucumber.e4f46696.png";